import React, { useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LinkedinIcon, Twitter, ChevronDown, ChevronUp } from 'lucide-react';
import Rajesh from '../../src/assets/images/RAJESH_AGARWAL.jpg'
import Rahul from '../../src/assets/images/Rahul_sharma.jpg'
export default function LeadershipPage() {
  const sectionRef = useRef(null);
  const [expandedId, setExpandedId] = useState(null);

  const leadershipData = [
    {
      name: "Rajesh Agarwal",
      role: "Chief Executive Officer",
      description: "Rajesh Agarwal is a prominent figure in India's electronics manufacturing sector, serving as the Co-founder of Bhagwati Products Limited (BPL). With a strong background in engineering, IT, and telecommunications, Agarwal has played a key role in expanding BPL's manufacturing capabilities. Under his leadership, the company has significantly advanced its production facilities and forged important partnerships to enhance local manufacturing.His strategic vision, along with his commitment to the 'Make in India' and 'Atmanirbhar Bharat' initiatives, has positioned BPL as a major player in the Indian electronics industry. His efforts in boosting local production and innovation continue to contribute to India's growing role in the global tech landscape.",
      linkedin: "https://linkedin.com/in/rajesh-kumar",
      image: Rajesh,
      twitter: "https://twitter.com/rajeshkumar"
    },
    {
      name: "Rahul Sharma",
      role: "Chief Technology Officer",
      description: "Rahul Sharma is the co-founder of Bhagwati Products Limited, a prominent name in the Indian technology and manufacturing sectors. His leadership has played a pivotal role in revolutionizing the technology space, particularly in the area of design and manufacturing. Rahul's vision has been instrumental in advancing the manufacturing capabilities of Bhagwati Products, allowing the company to produce high-quality electronics and drive innovation in the sector.His strategic approach to business has not only enhanced the technological infrastructure but also contributed to the 'Make in India' initiative by creating jobs and fostering local production. Rahul's leadership skills have empowered millions, inspiring a new generation of entrepreneurs and professionals to venture into technology and manufacturing. Through his work, he has shaped a future where India plays a significant role in the global technology landscape.",
      linkedin: "https://linkedin.com/in/sarah-mitchell",
      image: Rahul,
      twitter: "https://twitter.com/sarahmitchell"
    }
  ];

  return (
    <div ref={sectionRef} className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <div className="relative h-[50vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-orange-500/10 to-white/80" />
        <div className="relative z-10 text-center px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-6xl md:text-8xl font-bold tracking-tighter mb-6">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-yellow-500">
                Our Leadership
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-700 max-w-2xl mx-auto">
              Visionaries driving innovation and excellence
            </p>
          </motion.div>
        </div>
      </div>

      {/* Leadership Grid - Centered for Two Cards */}
      <div className="bg-gradient-to-b from-white via-orange-50/30 to-white">
      <div className="container mx-auto px-4 py-16 sm:py-24">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
            {leadershipData.map((leader, index) => (
              <motion.div
                key={index}
                
                className="group"
              >
                <div className="relative p-6 sm:p-8 rounded-2xl bg-white border  hover:shadow-2xl transition-all duration-300 border border-gray-100">
                  <div className="flex flex-col sm:flex-row items-center gap-6 mb-6">
                    {/* Image container with proper aspect ratio */}
                    <div className="w-48 sm:w-56 flex-shrink-0">
                      <div className="aspect-square rounded-xl overflow-hidden bg-gray-100 shadow-md">
                        <img
                          src={leader.image}
                          alt={leader.name}
                          className="w-full h-full object-cover transform "
                        />
                      </div>
                    </div>
                    <div className="flex-grow text-center sm:text-left">
                      <h3 className="text-2xl sm:text-3xl font-bold mb-2 text-gray-900">
                        {leader.name}
                      </h3>
                      <p className="text-orange-600 font-medium">{leader.title}</p>
                    </div>
                  </div>
                  
                  <div className="relative">
                    <AnimatePresence>
                      <motion.div
                        initial={{ height: expandedId === index ? "auto" : "100px" }}
                        animate={{ height: expandedId === index ? "auto" : "100px" }}
                        transition={{ duration: 0.3 }}
                        className="relative overflow-hidden"
                      >
                        <p className="text-gray-600 text-lg leading-relaxed">
                          {leader.description}
                        </p>
                        {expandedId !== index && (
                          <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent" />
                        )}
                      </motion.div>
                    </AnimatePresence>
                    
                    <button
                      onClick={() => setExpandedId(expandedId === index ? null : index)}
                      className="mt-4 text-orange-600 hover:text-orange-700 font-medium flex items-center gap-2 transition-colors duration-200"
                    >
                      {expandedId === index ? (
                        <>
                          Read Less <ChevronUp className="w-4 h-4" />
                        </>
                      ) : (
                        <>
                          Read More <ChevronDown className="w-4 h-4" />
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>


     
    </div>
  );
}